import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import { tokenInterceptor } from './auth/token.interceptor';
import { loadRuntimeConfig } from './shared/config/runtime-config';

// Default color theme - dynamically switchable via ThemeService
const defaultColorTheme = 'sky';

const AppPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: `{${defaultColorTheme}.50}`,
      100: `{${defaultColorTheme}.100}`,
      200: `{${defaultColorTheme}.200}`,
      300: `{${defaultColorTheme}.300}`,
      400: `{${defaultColorTheme}.400}`,
      500: `{${defaultColorTheme}.500}`,
      600: `{${defaultColorTheme}.600}`,
      700: `{${defaultColorTheme}.700}`,
      800: `{${defaultColorTheme}.800}`,
      900: `{${defaultColorTheme}.900}`,
      950: `{${defaultColorTheme}.950}`,
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAppInitializer(() =>
      loadRuntimeConfig(['/runtime-config.json', '/runtime-config.template.json'])
    ),
    provideRouter(routes),
    provideHttpClient(withInterceptors([tokenInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppPreset,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
    MessageService,
  ],
};
